exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, "[data-v-3796a08f] .tab-content.col{min-width:0}[data-v-3796a08f] .card-header-tabs{margin-top:0!important}.slot-tabs-end[data-v-3796a08f]{margin-left:auto}", ""]);

// exports
